import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { TIRE_SEARCH_COLUMNS, TIRE_SET_SEARCH_COLUMNS } from "./consts";
import { TireSetSearchResultsProps } from "./types";
import { useTranslate } from "helpers";
import TireRowChild from "./components/TireRowChild";

const TireSetSearchResults: React.FC<TireSetSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
    onLocationClick,
    onEditClick,
    onDemountClick,
    onMountClick,
    onRelocateClick,
    onWriteOffClick,
  } = props;

  const { t } = useTranslate();

  return (
    <>
      <TableSearch
        columns={TIRE_SET_SEARCH_COLUMNS(t, onDeleteClick, onLocationClick, onEditClick, onDemountClick, onMountClick, onRelocateClick, onWriteOffClick)}
        data={searchResults.data}
        // selectedRows={selectedRows}
        selectableRows={false}
        showSelectAll={false}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }

        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
        columnsChild={TIRE_SEARCH_COLUMNS(t)}
        CustomTableRowChild={TireRowChild}
      />
    </>
  );
};
export default memo(TireSetSearchResults);
